<template lang="html">
  <div>
    <v-row v-if="!showProfile">
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col
                cols="8"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in course name here"
                  append-icon="search"
                  label="Search course"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              
              <v-col
                v-if="$hasPermissionTo(['create courses'])"
                cols="2"
                offset-md="2"
              >
                <setup-training-courses-dialog-create
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-tabs
            v-model="active"
            color="black"
            class="pl-3"
          >
            <v-tab>
              All
            </v-tab>
            <v-tab
              v-for="(category, i ) in categories"
              :key="i"
            >
              {{ category.name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items 
            v-model="active"
          >
            <div
              data-simplebar
              class="overflow"
            >
              <v-row>
                <v-col
                  v-for="(course,i) in filteredCategories"
                  :key="i"
                  cols="3"
                  class=""
                >
                  <v-card
                    class="mx-auto px-0"
                    max-width="370"
                    @click="openProfile(course)"
                  >                
                    <v-img
                      :src="course.image_url"
                      height="194"
                    />

                    <v-list-item>
                      <v-list-item-content>                      
                        <v-list-item-title class="mb-1 font-weight-bold text-truncate">
                          {{ course.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-truncate">
                          {{ course.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-card-text class="pt-0">                   
                      <v-chip>
                        {{ course.classroom_type.name }}
                      </v-chip>
                    </v-card-text>                  
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <setup-training-courses-profile-view
      v-if="showProfile"
      :course-id="course.id"
    >
      <template v-slot:navigation>
        <v-breadcrumbs 
          :items="navItems" 
          divider="/"
          class="py-0"
        >
          <template v-slot:item="props">
            <a  
              :class="{ 
                'disabled': props.item.disabled, 
              }"       
              @click="updatePage"
            >{{ props.item.text }}</a>
          </template>
        </v-breadcrumbs>
      </template>
    </setup-training-courses-profile-view>
  </div>
</template>

<script>
  export default {
    components: {
      SetupTrainingCoursesDialogCreate: () => import('@/components/setup/training/courses/DialogCreate'),
      SetupTrainingCoursesProfileView: () => import('@/components/setup/training/courses/ProfileView'),
    },
    data: () => {
      return {
        navItems: [
          {
            text: 'Overview',
            disabled: false,
            to: { path: '/courses' }, 
            exact: true,
          },
          {
            text: 'Profile',
            disabled: true,
          },
        ],
        search: '',
        active: 0,
        courses: [],
        categories: [],
        showProfile: false,
        course: null,
      }
    },
    computed: {
      filteredCategories () {
        return this.courses.filter((course) => {
          return (this.active === 0 || course.course_category_id === this.categories[this.active - 1].id) &&
            course.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      updatePage () {
        this.loadCourses()
        this.showProfile = false
      },
      openProfile (course) {
        this.course = course
        this.showProfile = true
      },
      loadCourses () {
        this.$api.courses().list()
          .then((res) => {
            this.courses = res.data
          })
      },
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.courses().list(),
          this.$api.courseCategories().list(),
        ])
          .then(([courses, courseCategories]) => {
            this.courses = courses.data
            
            this.categories = courseCategories.data
            this.loading = false
          })
          .then(() => {
            this.loading = false
          })
      },
    },
  }
</script>

<style lang='css' scoped>
  .disabled {
      color: grey;
      pointer-events: none;
  }

  .overflow {
    height:80vh;
  }
</style>
